import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["direction", "spacing", "justifyContent", "alignItems", "children"];
import { Stack } from '@mui/material';
export var MuiStack = function (props) {
    var direction = props.direction, spacing = props.spacing, justifyContent = props.justifyContent, alignItems = props.alignItems, children = props.children, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Stack, _extends({
        spacing: spacing,
        direction: direction || 'row',
        justifyContent: justifyContent || 'start',
        alignItems: alignItems
    }, other), children);
};
